// extracted by mini-css-extract-plugin
module.exports = {"container":"text-editor_container__pV6To","container-text":"text-editor_container-text__2j7u5","fadeIn":"text-editor_fadeIn__3wQqv","fadeIn2":"text-editor_fadeIn2__5E1Cb"};